import { useEffect } from 'react';
import { useEffectOnce, useObservable } from 'react-use';
import { PanelControls } from '~/components/ui/PanelControls';
import { rage, useInputAction } from '~/rage';
import { InputAction } from '~/shared';
import { Head } from '../../components/Head';
import { Main } from '../../components/Main';
import { useStartExam } from '../../hooks';
import {
	resetStore,
	setSelectedIndexNext,
	setSelectedIndexPrev,
	useLayoutDispatch,
} from '../../redux';
import {
	StyledContainer,
	StyledControlsContainer,
} from './DrivingSchool.styled';

const DrivingSchool: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const { handleStartExam } = useStartExam();
	const modalState = useObservable(rage.modal.getCurrentModal());

	const leftControls = [
		{
			text: 'Управление',
			keys: ['ArrowLeft', 'ArrowRight'],
		},
		{
			text: 'Начать экзамен',
			keys: ['Enter'],
			onClick: () => {
				if (modalState) {
					return;
				}

				handleStartExam();
			},
		},
	];

	const rightControls = [
		{
			text: 'Выйти',
			keys: ['Esc'],
			onClick: () => {
				if (modalState) {
					return;
				}

				rage.drivingSchool
					.exit()
					.catch((err) => rage.notifications.showException(err));
			},
		},
	];

	useInputAction(InputAction.CommonMenuNavLeft, () => {
		if (modalState) {
			return;
		}

		dispatch(setSelectedIndexPrev());
	});
	useInputAction(InputAction.CommonMenuNavRight, () => {
		if (modalState) {
			return;
		}

		dispatch(setSelectedIndexNext());
	});
	useInputAction(InputAction.CommonMenuAccept, () => {
		if (modalState) {
			return;
		}

		handleStartExam();
	});
	useInputAction(InputAction.CommonMenuClose, () => {
		if (modalState) {
			return;
		}

		rage.drivingSchool
			.exit()
			.catch((err) => rage.notifications.showException(err));
	});

	useEffectOnce(() => {
		// Перетаскивание
		const handleDragging = (e: any) => {
			e.preventDefault();
		};
		document.addEventListener('dragstart', handleDragging);
		return () => document.removeEventListener('dragstart', handleDragging);
	});

	useEffect(() => {
		rage.drivingSchool.fetchExams();

		return () => {
			dispatch(resetStore());
		};
	}, []);

	return (
		<StyledContainer>
			<Head />
			<Main />
			<StyledControlsContainer>
				<PanelControls
					controls={leftControls}
					align={'left'}
					fullScreenLayout
				/>
				<PanelControls
					controls={rightControls}
					align={'right'}
					fullScreenLayout
				/>
			</StyledControlsContainer>
		</StyledContainer>
	);
};

export { DrivingSchool };
